import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import Typography from '@/v2/components/common/Typography'
import { MessagesProvider } from '@/v2/contexts/MessagesContext'
import { useConversation } from '@/v2/hooks/messages/useConversations'
import { useUpdateConversation } from '@/v2/hooks/messages/useConversations'
import PatientHeader from '../PatientHeader'
import MessagesHistory from '../MessagesHistory'
import ContactInfo from '../ContactInfo'
import Appointments from '../Appointments'
import AssignPatient from '../AssignPatient'
import styled from 'styled-components'
import {
  ConversationWrapper,
  ConversationContent,
  RightBar,
  SelectConversation,
} from './styles'
import Accordion from '@/v2/components/common/Accordion'

export const AccordionStyled = styled(Accordion)`
  margin-left: 10px;
  width: 95%;
`

const MessagesPage = ({ newConversation }) => {
  const theme = useTheme()
  const { conversationId } = useParams()
  const { conversation = {}, isLoading } = useConversation(conversationId)
  const { read = true, messages = {} } = conversation
  const { records, currentPage, totalPages } = messages
  const { updateConversation } = useUpdateConversation(conversationId)

  useEffect(() => {
    if (!read) {
      const setReadMessage = async () => {
        await updateConversation({ read: true })
      }
      setReadMessage()
    }
  }, [read])

  if (isLoading && !!conversationId)
    return (
      <ConversationWrapper>
        <SelectConversation>
          <Typography>Loading...</Typography>
        </SelectConversation>
      </ConversationWrapper>
    )

  const patients = conversation?.patients || []
  const [firstPatient] = patients || []
  const patient = newConversation?.patient || {
    patient: firstPatient || {},
    phoneNumber: conversation.phoneNumber,
  }

  return (
    <MessagesProvider patient={patient}>
      <ConversationWrapper>
        <PatientHeader patients={patients || []} conversation={conversation} />
        <ConversationContent>
          <MessagesHistory
            historyMessages={records}
            currentPage={currentPage}
            totalPages={totalPages}
          />
          <RightBar theme={theme.palette}>
            {patients?.length > 0 ? (
              patients.map(patient => (
                <AccordionStyled
                  noPaddingTitle
                  noBackground
                  key={patient.id}
                  defaultExpanded={patients.length === 1}
                  title={<Typography>{patient.fullName}</Typography>}
                  content={
                    <>
                      <ContactInfo
                        patient={patient}
                        conversation={conversation}
                      />
                      <Appointments patient={patient} />
                    </>
                  }
                />
              ))
            ) : (
              <AssignPatient phone={patient.phoneNumber} />
            )}
          </RightBar>
        </ConversationContent>
      </ConversationWrapper>
    </MessagesProvider>
  )
}

export default MessagesPage
